import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import Quill from 'quill';

@Component({
  selector: 'app-markdown-editorini',
  standalone: true,
  templateUrl: './markdown-editorini.html',
  styleUrl: './markdown-editorini.css',
})
export class MarkdownEditorini implements AfterViewInit, OnDestroy, OnChanges {
  @ViewChild('quillEditor', { static: true }) editorEl!: ElementRef<HTMLDivElement>;
  private quill?: Quill;

  /** ✅ Input: initial or externally updated content (HTML string) */
  @Input() value: string = '';

  /** ✅ Output: fires when content changes */
  @Output() valueChange = new EventEmitter<string>();

  /** Optional placeholder text */
  @Input() placeholder: string = 'Type your text here...';

  ngAfterViewInit() {
    // Initialize Quill
    this.quill = new Quill(this.editorEl.nativeElement, {
      modules: {
        toolbar: [
          [{ header: [1, 2, false] }],
          ['bold', 'italic', 'underline'],
          ['image', 'code-block'],
        ],
        // 👇 this disables dynamic resizing (even if Quill core tries to measure)
        clipboard: { matchVisual: false },
      },
      placeholder: this.placeholder,
      theme: 'snow',
    });

    // Set initial content if provided
    if (this.value) {
      this.quill.root.innerHTML = this.value;
    }

    // Listen for changes
    this.quill.on('text-change', () => {
      const html = this.quill!.root.innerHTML;
      this.valueChange.emit(html);
    });
  }

  /** Handle external updates to the value */
  ngOnChanges(changes: SimpleChanges) {
    if (this.quill && changes['value'] && !changes['value'].firstChange) {
      const newValue = changes['value'].currentValue || '';
      if (newValue !== this.quill.root.innerHTML) {
        this.quill.root.innerHTML = newValue;
      }
    }
  }

  ngOnDestroy() {
    this.quill = undefined;
  }

  /** Helper to read content programmatically */
  getContent() {
    return this.quill?.root.innerHTML || '';
  }
}
